import React, { useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import './Contact.css'; // Keep for component-specific styles

const Contact: React.FC = () => {
  const location = useLocation();
  const isDemo = location.search.includes('demo=true');
  
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    message: isDemo ? 'I am interested in requesting a demo.' : '',
    subject: isDemo ? 'Demo Request' : ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [submitStatus, setSubmitStatus] = useState<'success' | 'error' | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');
    setSubmitStatus(null);

    try {
      // Using Formspree as a form backend service
      // Replace 'YOUR_FORM_ID' with your actual Formspree form ID
      const formspreeUrl = 'https://formspree.io/f/xkgrkjre';
      
      await axios.post(formspreeUrl, formData);
      
      setSubmitStatus('success');
      setSubmitMessage('Thank you for your message! We will get back to you soon.');
      setFormData({ name: '', company: '', email: '', message: '', subject: isDemo ? 'Demo Request' : '' });
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
      setSubmitMessage('There was an error submitting your message. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-hero">
        <div className="container">
          <h1 className="text-center">{isDemo ? 'Request a Demo' : 'Contact Us'}</h1>
          <p className="text-center">
            {isDemo 
              ? "We're excited to show you how our graph intelligence platform can transform your risk assessment capabilities. Fill out the form below to schedule a personalized demo with our team."
              : "Have questions about our platform or interested in learning more? We'd love to hear from you. Fill out the form below or reach out directly at "}
            {!isDemo && <a href="mailto:contact@mycelo.io">contact@mycelo.io</a>}
          </p>
        </div>
      </div>
      
      <div className="container">
        {submitMessage && (
          <div className={`submit-message ${submitStatus}`}>
            {submitMessage}
          </div>
        )}
        
        <form className="form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Full Name</label>
            <input 
              type="text" 
              id="name" 
              name="name" 
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your name"
              required 
            />
          </div>

          <div className="form-group">
            <label htmlFor="company">Company</label>
            <input 
              type="text" 
              id="company" 
              name="company" 
              value={formData.company}
              onChange={handleChange}
              placeholder="Enter your company name"
              required 
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input 
              type="email" 
              id="email" 
              name="email" 
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              required 
            />
          </div>

          <input 
            type="hidden" 
            id="subject" 
            name="subject" 
            value={formData.subject}
          />

          <div className="form-group">
            <label htmlFor="message">Your Message</label>
            <textarea 
              id="message" 
              name="message" 
              rows={6} 
              value={formData.message}
              onChange={handleChange}
              placeholder="Tell us about your needs or questions"
              required
            ></textarea>
          </div>

          <div className="form-submit">
            <button 
              type="submit" 
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Contact;